import React from 'react';

export type Wrapper = React.FC<{ children: React.ReactNode }>;

export function wrapWith(
    wrappers: Wrapper[] = [],
    children: React.ReactNode
): React.ReactNode {
    return wrappers.reduceRight((acc, WrapperComponent) => {
        return <WrapperComponent>{acc}</WrapperComponent>;
    }, children);
}